import {
  Options,
  Vue
} from "vue-class-component";


@Options({ template: `<slot></slot>` })
export default class AllegationListHandler extends Vue { }